// landing.ts — where "/" sends you (Task 7, dashboard-shell cycle, handoff README §8). Pure
// and tested: this is the one branch in the cycle with real cases, and the dashboard has no
// component-test harness, so logic that can be tested lives where it can be.
export const LAST_BOT_KEY = 'embent:last-bot-id';
/** localStorage key for the active-workspace override — written by `WorkspaceMenu.tsx`
 * (switching), `InviteAccept.tsx` (accepting an invite), and read by `lib/api.ts`'s
 * `withWorkspaceHeader` on every outgoing request. */
export const WORKSPACE_KEY = 'embent:workspace';

/** `bots` must be the RESOLVED list — never call this while the query is in flight, or an
 * existing customer gets a flash of the signup wizard (handoff §8). Always returns a path,
 * never `null`. The rule (handoff §8, amended in Task 7 fix round 1 — the original brief had
 * every "no valid stored id" case fall back to `bots[0]`, which for a multi-bot workspace
 * meant dropping the visitor onto whichever bot they happened to create most recently, with no
 * sign the others exist):
 *
 * - zero bots            → `/onboarding`
 * - a stored id that's still in the list → that bot, regardless of how many bots there are
 * - otherwise, exactly one bot → that bot (the one-bot majority never sees the list)
 * - otherwise (2+ bots, no valid stored id) → `/bots` — the list is exactly what a first-ever
 *   login or a cleared `localStorage` needs to see, not a guess. */
export function resolveLandingPath(bots: { id: string }[], storedId: string | null): string {
  if (bots.length === 0) return '/onboarding';
  if (storedId && bots.some((b) => b.id === storedId)) return `/bots/${storedId}`;
  if (bots.length === 1) return `/bots/${bots[0]!.id}`;
  return '/bots';
}
